module.exports = __webpack_public_path__ + "static/img/pflanzen.9d27d1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pflanzen.jpg
// module id = 299
// module chunks = 0